import { IJsonAppointmentControlDto, IUpdateAppointmentControlDto, IUpdateAppointmentOccurrencesDto, IUpdateSingleOccurrenceDto, IDeleteAppointmentOccurrencesDto, IDeleteAppointmentOccurrencesResponse } from "../../models/dto/agendaApi/IAppointmentControlDto";
import { ICreateAgendaInBulk } from "../../models/input/agendaApi/ICreateAgendaInBulk";
import {
  ICreateAppoiment,
  ICreateAppointmentOccurrenceDto,
  ICreateWeeklyAppointmentDto,
  ICreateWeeklyAppointmentResultDto,
} from "../../models/input/agendaApi/ICreateAppoiment";
import { IUpdateAppoiment } from "../../models/input/agendaApi/IUpdateAppoiment";
import * as ApiWithToken from "../callApiWithToken";
const apiUrlAgenda = process.env.REACT_APP_AGENDAS_API;

const AgendaManagement = {
  getStateByCountry: async function (countryID: number) {
    return ApiWithToken.getApi(
      `${apiUrlAgenda}AngendaManagement/GetStateByCountry?countryId=${countryID}`
    );
  },

  getCityByState: async function (stateID: number) {
    return ApiWithToken.getApi(
      `${apiUrlAgenda}AngendaManagement/GetCityByState?stateId=${stateID}`
    );
  },

  getAdvisorsBySupervisors: async function (cityID: number) {
    return ApiWithToken.getApi(
      `${apiUrlAgenda}AngendaManagement/GetAdvisorsBySupervisors?cityID=${cityID}`
    );
  },

  getAppointmentsByUser: async function (userID: number, languageID: number) {
    return ApiWithToken.getApi(
      `${apiUrlAgenda}AngendaManagement/GetAppointmentsByUser?userID=${userID}&languageID=${languageID}`
    );
  },

  deleteAppointment: async function (appointmentID: number) {
    return ApiWithToken.putApi(`${apiUrlAgenda}AngendaManagement/DeleteAppointment`, {
      appointmentID: appointmentID,
    });
  },

  postCreateAppointment: async function (form: ICreateAppoiment) {
    return ApiWithToken.postApi(`${apiUrlAgenda}AngendaManagement/CreateAppointment`, form);
  },

  postUpdateAppointment: async function (form: IUpdateAppoiment) {
    return ApiWithToken.putApi(`${apiUrlAgenda}AngendaManagement/UpdateAppointment`, form);
  },

  createAppointmentInBulk: async function (json: ICreateAgendaInBulk[]) {
    return ApiWithToken.postApi(`${apiUrlAgenda}AngendaManagement/CreateAppointmentInBulk`, json);
  },

  getAppointmentsByType: async function (languageID: number) {
    return ApiWithToken.getApi(`${apiUrlAgenda}AngendaManagement/GetAppointmentsByType?languageID=${languageID}`);
  },

  deleteAppointmentInBulk: async function (appointmentIDs: string) {
    return ApiWithToken.postApi(`${apiUrlAgenda}angendaManagement/DeleteAppointmentInBulk`, appointmentIDs);
  },
  appointmentControlTemplate: async function (languageID: number) {
    return ApiWithToken.getApiBlob(`${apiUrlAgenda}AngendaManagement/GetAppointmentControlTemplate?languageID=${languageID}`);
  },
  insertAppointmentControl: async function (json: IJsonAppointmentControlDto[]) {
    return ApiWithToken.postApi(`${apiUrlAgenda}AngendaManagement/InsertAppointmentControl`, json);
  },
  getAppointmentControl: async function (startDate: string, endDate: string) {
    return ApiWithToken.getApi(`${apiUrlAgenda}AngendaManagement/GetAppointmentControl?startDate=${startDate}&endDate=${endDate}`);
  },
  deleteAppointmentControl: async function (appointmentID: number) {
    return ApiWithToken.postApi(`${apiUrlAgenda}AngendaManagement/DeleteAppointmentControl`, appointmentID);
  },
  updateAppointmentControl: async function (updateAppointment: IUpdateAppointmentControlDto) {
    return ApiWithToken.postApi(`${apiUrlAgenda}AngendaManagement/UpdateAppointmentControl`, updateAppointment);
  },
  updateAppointmentOccurrences: async function (input: IUpdateAppointmentOccurrencesDto) {
    return ApiWithToken.postApi(`${apiUrlAgenda}AngendaManagement/UpdateAppointmentOccurrences`, input);
  },
  updateSingleAppointmentOccurrence: async function (input: IUpdateSingleOccurrenceDto) {
    return ApiWithToken.putApi(`${apiUrlAgenda}AngendaManagement/UpdateSingleAppointmentOccurrence`, input);
  },
  deleteAppointmentOccurrences: async function (input: IDeleteAppointmentOccurrencesDto): Promise<IDeleteAppointmentOccurrencesResponse> {
    return ApiWithToken.deleteApiWithBody(
      `${apiUrlAgenda}AngendaManagement/DeleteAppointmentOccurrences`,
      input
    );
  },
  createAppointmentOccurrence: async function (form: ICreateAppointmentOccurrenceDto) {
    return ApiWithToken.postApi(`${apiUrlAgenda}AngendaManagement/CreateAppointmentOccurrence`, form);
  },
  createWeeklyAppointment: async function (
    form: ICreateWeeklyAppointmentDto
  ): Promise<ICreateWeeklyAppointmentResultDto[] | { statusCode: number }> {
    return ApiWithToken.postApi(
      `${apiUrlAgenda}AngendaManagement/CreateWeeklyAppointment`,
      form
    );
  },
  getAppointmentOccurrencesByUser: async function (userID: number, languageID: number, targetDate?: string) {
    const dateParam = targetDate ?? new Date().toISOString().split("T")[0];
    return ApiWithToken.getApi(
      `${apiUrlAgenda}AngendaManagement/GetAppointmentOccurrencesByUser?userID=${userID}&languageID=${languageID}&targetDate=${dateParam}`
    );
  },
};

export default AgendaManagement;
